import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';

import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';
import { IvrRoutingModule } from './ivr-routing.module';
import { IvrListComponent } from './ivr-list/ivr-list.component';
import { IvrComponent } from './ivr.component';
import { IvrTableDataSource } from './ivr-list/ivr-list.data';
import { IvrDetailsComponent } from './ivr-details/ivr-details.component';
import { KeypadComponent } from './ivr-details/keypad/keypad.component';
import { KeyComponent } from './ivr-details/keypad/key/key.component';
import { IvrActionsComponent } from './ivr-details/ivr-actions/ivr-actions.component';
import { IvrResolver } from './ivr-details/ivr.resolver';
import { IvrsResolver } from './ivrs.resolver';
import { IvrService } from './ivr.service';
import { IvrMsisdnsResolver } from './ivr-details/ivr-msisdns.resolver';
import { InboundableMsisdnResolver } from './inboundable-msisdns.resolver';
import { IvrNotAvailableComponent } from './ivr-not-available/ivr-not-available.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { UI_SWITCH_CONFIGURATION } from '../shared/utils/layoutUtils';


@NgModule({
  imports: [CommonModule, SharedModule, LayoutModule, TranslateModule, NgxPermissionsModule, IvrRoutingModule,     UiSwitchModule.forRoot(UI_SWITCH_CONFIGURATION)],
  providers: [IvrTableDataSource, IvrResolver, InboundableMsisdnResolver, IvrsResolver, IvrMsisdnsResolver, IvrService],
  declarations: [
    IvrListComponent,
    IvrComponent,
    IvrDetailsComponent,
    KeypadComponent,
    KeyComponent,
    IvrActionsComponent,
    IvrNotAvailableComponent
  ],
  exports: [IvrComponent],
  entryComponents: [IvrComponent]
})
export class IvrModule {}
